import React, { useState } from 'react'
import { Grid, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, Box } from '@mui/material';
import "../../../../scss/common.scss";
import "../Invoice/invoice.scss";
import { myCompanyInvoiceData, InvoiceTableData } from '../../../../mock-data/my-company-invoice-mock-data';
import InvoiceViewModal from "../invoice-view-modal";
import ActionHeader from '../../../../UI/action-header/action-header';
import ActionBtn from '../../../../UI/global-buttons/action-button/action-button';

const Invoice = () => {
  const [checkboxAllSelected, setCheckboxAllSelected] = useState<boolean>(false);
  const [checkboxSingleSelected, setCheckboxSingleSelected] = useState<any>([]);
  const [selectedRecord, setSelectedRecord] = useState({});
  const [openPdfModal, setOpenPdfModal] = useState(false);

  const handleSelectAllChecked = () => {
    setCheckboxAllSelected(!checkboxAllSelected);
    setCheckboxSingleSelected(InvoiceTableData.map((li: any) => li.listId));
    if (checkboxAllSelected) {
      setCheckboxSingleSelected([]);
    }
  };

  const handleSingleChecked = (
    e: React.ChangeEvent<HTMLInputElement>,
    item: any
  ) => {
    const { id, checked } = e.target;
    const { listId } = item;
    setCheckboxSingleSelected([...checkboxSingleSelected, listId]);
    if (!checked) {
      setCheckboxSingleSelected(
        checkboxSingleSelected.filter((item: any) => item !== id)
      );
    }
  };

  const gettype = (param: string) => {
    console.log(param);
  }

  return (
    <>
      {/* invoise history bar */}
      <Box sx={{ mb: 4 }}>
        <ActionHeader heading='Invoice History' />
      </Box>

      {/* ACTION BUTTON */}
      <Box display="flex" justifyContent="end" paddingBottom="20px">
        <ActionBtn disable={false} list={['Export CSV File', 'Download']} selectedItem={gettype} />
      </Box>
      <div className='main-invoice padding-class'>
        <Grid container padding="20px" className='box-shadow br-8'>
          <TableContainer>
            <Table>
              <TableHead>
                {myCompanyInvoiceData.map((item: any) => (
                  <>
                    <TableRow className='secondary-color' key={item.id}>
                      <TableCell ><input type="checkbox" onChange={() => handleSelectAllChecked()} checked={checkboxAllSelected} className="table-checkbox" /></TableCell>
                      <TableCell className='font-size-14 font-weight-500 headcolor'>{item.avatar}</TableCell>
                      <TableCell className='font-size-14 font-weight-500 headcolor'>{item.billingDate}</TableCell>
                      <TableCell className='font-size-14 font-weight-500 headcolor'>{item.amount}</TableCell>
                      <TableCell className='font-size-14 font-weight-500 headcolor'>{item.invoiceNo}</TableCell>
                      <TableCell className='font-size-14 font-weight-500 headcolor cursor-pointer'>{item.details}</TableCell>
                    </TableRow>
                  </>
                ))}
              </TableHead>
              <TableBody>
                {InvoiceTableData.map((data: any) => (
                  <TableRow key={data.listId}>
                    <TableCell>
                      <input
                        key={data.listId}
                        type="checkbox"
                        id={data.listId}
                        name={data.listId}
                        checked={checkboxSingleSelected.includes(data.listId)}
                        onChange={(e) => {
                          handleSingleChecked(e, data);
                        }}
                        className="table-checkbox table-tbody-checkbox "
                      />
                    </TableCell>
                    <TableCell><img src={data.avatar} alt="" /></TableCell>
                    <TableCell>{data.billingDate}</TableCell>
                    <TableCell>{data.amount}</TableCell>
                    <TableCell>{data.invoiceNo}</TableCell>
                    <TableCell><img src={data.details} alt="" className='cursor-pointer' onClick={() => { setOpenPdfModal(true); setSelectedRecord(data) }} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <InvoiceViewModal openPdfModal={openPdfModal} closePdfModal={() => { setOpenPdfModal(false) }} selected={selectedRecord} />
        </Grid>

      </div>
    </>
  )
}
export default Invoice
